import { axiosInstance } from "@retro-ia/shared/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

export const useDeleteLogicoActividadPrograma = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: number | string) => {
      const res = await axiosInstance.put(
        `/actividades-programa/${id}`,
        undefined,
        {
          withCredentials: true,
        }
      );
      return res.data;
    },
    onSuccess: () => {
      toast.success("La actividad fue eliminada.");
      queryClient.invalidateQueries({ queryKey: ["actividadesProgramas"] });
    },
    onError: () => {
      toast.error("Error al eliminar la actividad.");
    },
  });
};
